import React, { useState, useEffect } from "react";
import ModalImage from "react-modal-image";
import "./GalleryPage.css";
// import headerBackgroundImage from "../Mission/lagacy/card-background-2.png";
const ImageComponent = ({ src, alt, title, description }) => {
  return (
    <div className="hover:shadow-2xl bg-slate-100 hover:scale-125 transition duration-500 rounded-xl border-2">
      <div className="image-container">
        <ModalImage
        className="rounded-xl w-full "
          small={src}
          large={src}
          alt={alt}
        />
        {/* <h2 className="text-center">{title}</h2>
        <h2 className="text-center">{description}</h2> */}
      </div>
    </div>
  );
};
const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("http://snmsangli.com/api/media/get_media")
      .then((response) => response.json())
      .then((data) => {
        console.error(data);
        setImages(data);
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
      });
  }, []);

  return (
    <div
      className="pt-6 "
    >
      <h2 className=" border-b-2 border-blue-900 w-[18%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] rounded-2xl">
        Our Gallery
      </h2>
      {/* <h2 className='text-center text-blue-800 font-bold text-4xl pt-8'>Photo Gallery</h2> */}
      <div className=" gallery-container grid-cols-1 px-20 py-10 gap-4  grid lg:grid-cols-3">
      <ImageComponent
          src="image/gallery/one.jpg"
          alt="ImageComponent"
          title="Image One"
          description="Description One"
        />
        <ImageComponent
          src="image/gallery/two.jpg"
          alt="ImageComponent"
          
        />
        <ImageComponent
          src="image/gallery/ten.jpg"
          alt="ImageComponent"
          
        />
        <ImageComponent
          src="image/gallery/three.jpg"
          alt="ImageComponent"
          
        />
        <ImageComponent
          src="image/gallery/five.jpg"
          alt="ImageComponent"
          
        />
        <ImageComponent
          src="image/gallery/six.jpg"
          alt="ImageComponent"
          
        />
        <ImageComponent
          src="image/gallery/seven.jpg"
          alt="ImageComponent"
          
        />
        <ImageComponent
          src="image/gallery/eight.jpg"
          alt="ImageComponent"
          
        />

        {images.map((data) => (
          <div
            className="md:w-[330px] transition-opacity rounded-lg p-4 border-2"
            key={data.id}
          >
            <div className="image-container">
              <ModalImage
                className="w-60 mx-auto h-60"
                small={`http://localhost:7000/uploads/${encodeURIComponent(
                  data.media_photo
                )}`}
                large={`http://localhost:7000/uploads/${encodeURIComponent(
                  data.media_photo
                )}`}
                alt={data.media_title}
                // className="gallery-image"
              />
              <h2 className="text-center">{data.media_title}</h2>
              <h2 className="text-center">{data.media_description}</h2>
              {/* <ImageComponent src={data.media_photo}> */}
              {/* <ImageComponent   src={`http://localhost:7000/uploads/${encodeURIComponent(data.media_photo)}`}></ImageComponent> */}

              {console.log(data.media_photo)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
